var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef } from '@angular/core';
let BsModalDragDirective = class BsModalDragDirective {
    constructor(_element) {
        this._element = _element;
    }
    ngAfterViewInit() {
        setTimeout(() => this.setDrag(), 1000);
    }
    setDrag() {
        const currentEle = $(this._element.nativeElement);
        const targets = currentEle.parents('.modal-content');
        if (targets.length === 0) {
            return;
        }
        $(targets[0]).draggable({
            cursor: 'pointer',
            handle: '.modal-header',
            containment: 'body',
            scroll: false
        });
    }
};
BsModalDragDirective = __decorate([
    Directive({
        selector: '[bs-modal-drag]'
    }),
    __metadata("design:paramtypes", [ElementRef])
], BsModalDragDirective);
export { BsModalDragDirective };
